import React from 'react';

import {BaseMatchModel} from "../../../../../core/components/router/models/base-match-model";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {CompetitionBracketsPageController} from "../competition-brackets-page.controller";
import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {BracketsWidgetAsync} from "../../../../../widgets/brackets-widget/components/brackets-widget.async";
import {useLocation} from "react-router-dom";

export class CompetitionBracketsPageComponentProps extends BaseModuleProps {
  match: BaseMatchModel;
}

export const CompetitionBracketsPageComponent = ({controller}) => {
  const location = useLocation();

  const {state} = controller;
  const {competitionId} = state;

  const bracketsWidgetProps = {
    competitionIds: [competitionId],
    location: location,
  }

  return (
    <BracketsWidgetAsync {...bracketsWidgetProps}/>
  )
};

const settings: ComposeSettings = {
  component: CompetitionBracketsPageComponent,

  observe: true,
  createModule: true,
  useMetadata: true,

  propsType: CompetitionBracketsPageComponentProps,
  controllerType: CompetitionBracketsPageController,
};

export const CompetitionBracketsPage = Compose(settings);

export default CompetitionBracketsPage;
